import { Option } from "@nozzlegear/railway";
import * as Frontend from "kmmp/frontend";
import { useReducer } from "react";
import { ExhaustiveCheckError } from "shared/errors";

export type PortraitFormState = {
    backgroundVariant: Frontend.BackgroundImage
    frameVariant: Option<Frontend.FrameImage>
    orientation: Option<Frontend.Orientation>
    purchaseOrderId: string
    frameSize: Frontend.FrameSize
}

export type PortraitFormAction
    = { type: "setBackground", value: Frontend.BackgroundImage }
    | { type: "setFrame", value: Frontend.FrameImage }
    | { type: "setOrientation", value: Frontend.Orientation }
    | { type: "setPurchaseOrderId", value: string }
    | { type: "setFrameSize", value: Frontend.FrameSize }

export type PortraitFormDispatch = React.Dispatch<PortraitFormAction>

type PortraitFormReducer = (state: PortraitFormState, action: PortraitFormAction) => PortraitFormState;

const reduce: PortraitFormReducer = (state, action) => {
    switch (action.type) {
        case "setBackground":
            return { ...state, backgroundVariant: action.value }
        case "setFrame":
            return { ...state, frameVariant: Option.ofSome(action.value) }
        case "setOrientation":
            return { ...state, orientation: Option.ofSome(action.value) }
        case "setPurchaseOrderId":
            return { ...state, purchaseOrderId: action.value }
        case "setFrameSize":
            return { ...state, frameSize: action.value }
        default:
            throw new ExhaustiveCheckError(action)
    }
}

function mapInitialState(defaultBackground: Frontend.BackgroundImage): PortraitFormState {
    return {
        backgroundVariant: defaultBackground,
        frameVariant: Option.ofNone(),
        orientation: Option.ofNone(),
        purchaseOrderId: "",
        frameSize: "16x20",
    }
}

export const usePortraitFormReducer: (defaultBackground: Frontend.BackgroundImage) => [PortraitFormState, PortraitFormDispatch] = (background) => {
    return useReducer<PortraitFormReducer, Frontend.BackgroundImage>(reduce, background, mapInitialState);
}
